import React from 'react';
import Header from "./components/Header";
import Presentional from "./components/Presentational";
import UpcomingShows from "./components/UpcomingShows";
import VideoSection from "./components/VideoSection";
import MusicSection from "./components/MusicSection";
import Footer from "./components/Footer"

const App = () => {
    //setting body bgcolor
    const bodyCon = document.querySelector("body");
    bodyCon.style.backgroundColor = "#000000"
    return (
        <div className="ui container main-container">
            <Header />
            <Presentional />
            <UpcomingShows />
            <VideoSection />
            <MusicSection />
            <Footer />
        </div>
    )
}
//#efefef;
export default App
